// Mock file upload utility
// In a real application, this would upload to a server or cloud storage

export const uploadFile = async (file) => {
  return new Promise((resolve, reject) => {
    try {
      // Simulate upload delay
      setTimeout(() => {
        // Create a mock file path
        const fileName = `uploaded_${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.-]/g, '_')}`
        const filePath = `/uploads/${fileName}`
        
        // In a real app, you would:
        // 1. Upload the file to a server/cloud storage
        // 2. Get back the actual URL
        // 3. Return that URL
        
        // For demo purposes, we'll use object URLs or base64
        const reader = new FileReader()
        reader.onload = () => {
          resolve({
            url: filePath,
            dataUrl: reader.result, // This is what we'll actually use for display
            filename: fileName,
            originalName: file.name,
            size: file.size,
            type: file.type
          })
        }
        reader.onerror = () => reject(new Error('Failed to read file'))
        reader.readAsDataURL(file)
      }, 500) // Simulate 500ms upload time
    } catch (error) {
      reject(error)
    }
  })
}

export const deleteFile = async (filePath) => {
  // In a real app, this would delete the file from storage
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log(`Deleted file: ${filePath}`)
      resolve(true)
    }, 200)
  })
}

// Utility to validate file types
export const validateFile = (file, allowedTypes = ['image/jpeg', 'image/png', 'image/webp']) => {
  if (!allowedTypes.includes(file.type)) {
    throw new Error(`File type ${file.type} is not allowed. Allowed types: ${allowedTypes.join(', ')}`)
  }
  
  // Additional validations
  if (file.size > 5 * 1024 * 1024) { // 5MB
    throw new Error('File size must be less than 5MB')
  }
  
  return true
}

// Utility to generate optimized file names
export const generateFileName = (originalName, prefix = 'slide') => {
  const timestamp = Date.now()
  const extension = originalName.split('.').pop()
  const cleanName = originalName.replace(/[^a-zA-Z0-9.-]/g, '_')
  return `${prefix}_${timestamp}_${cleanName}`
}